import React, { useCallback, useState } from "react";
import EditIcon from "../../../assets/icons/lucide_edit.svg";
import Pagination from "../../../components/commons/Pagination";
import mobioApi from "../../../services";
import { useNavigate } from "react-router";
import { formatDateWithDays } from "../../../helpers/formatDateWithDays";

const RenderScreen = ({
  token,
  menuType,
  currentPage,
  setCurrentPage,
  orderFilter,
  searching,
  setTotalRecords,
}) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [onBoardingData, setOnBoarding] = useState([]);

  const getOnboardingDriverList = useCallback(
    async (page = 1, limit = 10) => {
      try {
        setLoading(true);
        const api = mobioApi(token);
        const response = await api.getOnboardingList(
          page,
          limit,
          menuType,
          orderFilter,
          searching
        );

        setTotalRecords(response?.data?.pagination?.totalCount || 0);

        return {
          items: response?.data?.data || [],
          total: response?.data?.pagination?.totalCount || 0,
        };
      } catch (error) {
        return { items: [], total: 0 };
      } finally {
        setLoading(false);
      }
    },
    [token, menuType, orderFilter, searching]
  );

  const handlePageChange = useCallback((items) => {
    setOnBoarding(items);
  }, []);

  return (
    <div>
      <table className="custom-table-v3">
        <thead>
          <tr>
            <th>Full Name</th>
            <th>Registered Date</th>
            <th>Role</th>
            <th>City</th>
            <th>Email</th>
            <th>Phone Number</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <>
              <tr>
                <td colSpan={7}>
                  <div className="text-align-center">Loading...</div>
                </td>
              </tr>
            </>
          ) : (
            <>
              {onBoardingData?.map((row, index) => (
                <tr key={index}>
                  <td>
                    <div className="flex align-item-center">
                      <img
                        src={
                          row?.user?.imageUrl ||
                          "https://avatar.iran.liara.run/public/29"
                        }
                        alt="icon"
                        className="avatar-md"
                      />
                      <p className="ml-10"> {row?.user?.fullName}</p>
                    </div>
                  </td>
                  <td>{formatDateWithDays(row?.user?.createdAt)}</td>
                  <td>{row?.user?.role}</td>
                  <td>{row?.user?.activeCity}</td>
                  <td>{row?.user?.email}</td>
                  <td>{row?.user?.phoneNumber}</td>

                  <td>
                    <img
                      src={EditIcon}
                      className="cursor-pointer"
                      style={{ width: "23px", height: "23px" }}
                      onClick={() => {
                        navigate(
                          `/dashboard/onboardings/user-detail/${
                            row?.userId || row?.user?.id
                          }`,
                          {
                            state: {
                              status: menuType,
                              page: currentPage,
                            },
                          }
                        );
                      }}
                    />
                  </td>
                </tr>
              ))}
            </>
          )}
        </tbody>
      </table>

      <div
        style={{
          backgroundColor: "white",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Pagination
          fetchData={getOnboardingDriverList}
          itemsPerPage={10}
          onPageChange={handlePageChange}
          currentPage={currentPage}
          onCurrentPageChange={(page) => setCurrentPage(page)}
        />
      </div>
    </div>
  );
};

export default RenderScreen;
